<template>
    <fwb-navbar>
        <template #logo>
            <Link href="/">   
                <p class="text-2xl font-bold">PayNow</p>
            </Link>
        </template>
        <template #default="{ isShowMenu }">
            <fwb-navbar-collapse class="flex">
                <Link v-for="item in navbarItems" :key="item.name" :href="item.href">
                    <fwb-navbar-link>
                        {{ item.name }}
                    </fwb-navbar-link>
                </Link>

            </fwb-navbar-collapse>
        </template>
    </fwb-navbar>
</template>

<script setup>
import {
    FwbNavbar,
    FwbNavbarCollapse,
    FwbNavbarLink,
    FwbNavbarLogo,
    FwbDropdown
} from 'flowbite-vue';
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3'
import { Link } from '@inertiajs/vue3'


const navbarItems = computed(() => {
    const items = [
        { name: 'Home', href: '/' },
    ]
    if (!user.value) {
        items.push({ name: 'Login', href: '/users/login' })
    } else {
        items.push({ name: `Logout (${user.value.username})`, href: '/users/logout' })
    }

    return items
});
const page = usePage()
const user = computed(() => page?.props?.authUser)
</script>
